var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-loader-error", {
    attrs: {
      title: _vm.$t("forbidden.title"),
      message: _vm.$t("forbidden.message"),
      icon: "error-alert",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }